import {Component, OnInit} from '@angular/core';
import {PromotionCampaignService} from '../../../services/promotion/promotion-campaign.service';
import {PromotionCampaignModel} from '../../../models/promotion-campaign.model';
import {TranslateService} from '@ngx-translate/core';
import {PromotionWizardService} from '../../../services/promotion/promotion-wizard.service';
import {PromotionCampaignTypeService} from '../../../services/promotion/promotion-campaign-type.service';
import {PromotionTouchPointService} from '../../../services/promotion/promotion-touch-point.service';
import {KontableComponent} from '../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'kv-promo-campaign',
  template: `
    <app-kontable
      id="dt_brand"
      title="{{ 'promotion.campaignTitle' | translate }}"
      [columns]="['code', { field: 'start_date', title: 'customerInfoSheet.startDate'}, { field: 'end_date', title: 'customerInfoSheet.endDate'}, 'small_description']"
      [titles]="['promotion.code', 'promotion.smallDescription' ]"
      [service]="svcCampaign"
      [paginationType]="paginationType"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      [name]="'promotion.messageTable'"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-campaign-detail
        *ngIf="show"
        (hide)="toggleShow()"
        [titlePage]="titlePage"
        [wizardCampaigns]="wizardCampaigns"
        [addEditCampaign]="addEditCampaign"
        [campaignTypes]="campaignTypes"
        [touchPoints]="touchPoints">
    </kv-promo-campaign-detail> 
  `
})
export class CampaignComponent implements OnInit {

  campaigns: PromotionCampaignModel[];
  addEditCampaign: PromotionCampaignModel;
  paginationType = KontableComponent.ServerPagination;
  show = false;
  titlePage: string;
  wizardCampaigns;
  campaignTypes;
  chooseCampaignType;
  touchPoints = [];

  constructor(
    private svcCampaign: PromotionCampaignService,
    private svcWizard: PromotionWizardService,
    private svcCampaignType: PromotionCampaignTypeService,
    private srvTranslate: TranslateService,
    private svcTouchPoint: PromotionTouchPointService
  ) {
    this.srvTranslate.get(['promotion.chooseCampaignType']).subscribe((res) => {
      this.chooseCampaignType = res['promotion.chooseCampaignType']
    });
    svcWizard.list(null, null, [
      {
        key: 'type',
        value: 'campaign'
      }
    ]).subscribe(res => {
      this.wizardCampaigns = [];
      for (let elem of res.data) {
        this.wizardCampaigns.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcCampaignType.list().subscribe( (res) => {
      this.campaignTypes = [{label: this.chooseCampaignType, value: null}];
      for (let elem of res.data) {
        this.campaignTypes.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
    svcTouchPoint.list().subscribe( (res) => {
      /*filtro quelli che non sono stati eliminati*/
      let newArray = res.data.filter( function (e) {
        return e['flg_state'] === '0';
      });
      /*riempio il vettore*/
      for (let elem of newArray) {
        this.touchPoints.push({
          label: elem.code + ' - ' + elem.description,
          value: elem.id
        })
      }
    });
  }

  ngOnInit(): void {}

  delete(item) {
    this.svcCampaign.delete(item.id).subscribe( () => {
      KontableComponent.signalDataChange.emit({name: 'promotion.messageTable'});
    });
  }
/*
  reloadList() {
    this.campaigns = [];
    this.svcCampaign.list(0, 999999).subscribe( res => {
      this.campaigns = res.data;
    });
  }
*/
  showEdit(item) {
    this.svcCampaign.get(item.id).subscribe((res) => {
      this.addEditCampaign = res;
      this.titlePage = 'promotion.updateCampaign';
      this.toggleShow();
    });
  }

  showAdd() {
    this.titlePage = 'promotion.addCampaign';
    this.addEditCampaign = null;
    this.toggleShow()
  }

  toggleShow() {
    this.show = !this.show
  }

  // FIXME: la kontable prendere correttamente in input il service in questo modo:
  //  [service]="svcCampaign" e [paginationType]="paginationType" ma a seguito ad esempio
  //  di una semplice delete, chiamata con this.svcCampaign.delete(id).subscribe() la
  //  kontable non viene aggiornata in automatico

}





// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/campaign.component.ts